<template>
  <header>
    <div
      class="nav_container"
      :style="{
        background: menuActive || langShow ? 'rgba(0, 0, 0, 0.3)' : '',
      }"
    >
      <nav>
        <router-link to="/" class="logo">
          <img src="../assets/img/appImg/logo.png"
        /></router-link>

        <ul
          class="nav-links"
          :class="{ active: menuActive }"
          v-if="!activeNav.length"
        >
          <li v-for="(link, i) in list" :key="i" @click="navClick(link, i, 0)">
            <span>{{ link.name }}</span>
            <div class="arrow-right" v-if="i != 0"></div>
          </li>
        </ul>
        <div class="nav_right">
          <div style="margin-top: 4px" @click="toPage('/fullSearch')">
            <img src="../assets/img/appImg/search_icon.png" />
          </div>

          <div
            class="lang_con"
            @click="toggleLang"
            :style="{ background: langShow ? '#fff' : '' }"
          >
            {{ siteName }}
          </div>
          <div
            class="menu-toggle"
            @click="toggleMenu"
            :style="{ background: menuActive ? '#fff' : '' }"
          >
            ☰
          </div>
        </div>
      </nav>
      <!--  导航切换-->
      <div class="subnav" v-if="activeNav.length">
        <div class="back_con" @click="toback">
          <img src="../assets/img/appImg/fanhui_icon.png" />{{ $t('back') }}
        </div>
        <div class="subnav_title">{{ activeName }}</div>
        <ul class="subnav_list">
          <li
            v-for="(link, i) in activeNav"
            :key="i"
            @click="navClick(link, i, 0)"
          >
            <span>{{ link.name }}</span>
          </li>
        </ul>
      </div>
      <!-- 站点切换 -->
      <div class="subnav" v-if="langShow">
        <ul class="subnav_list">
          <li
            v-for="(link, i) in siteList"
            :key="i"
            @click="langClick(link, i)"
          >
            <span>{{ link.siteName }}</span>
            <img
              v-if="langIndex == i"
              src="../assets/img/appImg/selected_icon.png"
            />
          </li>
        </ul>
      </div>
    </div>
  </header>
</template>

<script>
import { navList } from '@/const';
import { setSiteOne } from '@/assets/api/token.js';
import { getColumnAll } from '@/const';
export default {
  name: 'Header',
  data() {
    return {
      menuActive: false,
      langShow: false,
      siteName: '',
      siteValue: '',
      siteList: [],
      activeNav: [],
      activeName: '',
      langIndex: 0,
      list: navList,
    };
  },
  mounted() {
    this.siteList = this.$store.state.siteList;
    this.siteValue = this.$store.state.siteValue;
    this.siteList.map((l, index) => {
      if (l.id == this.$store.state.siteValue) {
        this.siteName = l.siteName;
        this.langIndex = index;
      }
    });
    this.list.map((l) => {
      if (l.accessPath == '/') {
        l.name = this.$t('home');
      } else if (l.accessPath == '/fullSearch') {
        l.name = this.$t('fullSearch');
      } else if (l.accessPath == '/mediaRegist') {
        l.name = this.$t('mediaRegist');
      }
    });
  },
  methods: {
    getColumnList() {
      const navObj = getColumnAll();
      this.list = navObj.headNav;
      this.options = navObj.moreTab.tab;
      this.list.map((l) => {
        if (l.accessPath == '/') {
          l.name = this.$t('home');
        } else if (l.accessPath == '/fullSearch') {
          l.name = this.$t('fullSearch');
        } else if (l.accessPath == '/mediaRegist') {
          l.name = this.$t('mediaRegist');
        }
      });
    },
    toggleMenu() {
      this.menuActive = !this.menuActive;
      this.langShow = false;
    },
    toggleLang() {
      this.langShow = !this.langShow;
      this.menuActive = false;
      this.activeNav = [];
    },
    navClick(v, i) {
      if (v.subnav) {
        this.activeName = v.name;
        this.activeNav = v.subnav;
      } else {
        this.$router.push({
          path: v.accessPath,
          query: {
            cloumnId: v.id,
          },
        });
        this.menuActive = false;
        document.documentElement.scrollTop = 0;
      }
    },
    langClick(v, i) {
      this.langIndex = i;
      this.langShow = false;
      this.siteValue = v.id;
      this.siteName = v.siteName;
      this.$store.commit('setSiteValue', v.id);
      setSiteOne(v.id);
      this.$store.dispatch('getCloumn').then((res) => {
        let keywords = '';
        this.siteList.map((s) => {
          if (s.id == v.id) {
            keywords = s.keywords;

            this.$i18n.locale = keywords.includes('en') ? 'en' : 'zh';
            localStorage.setItem('language', this.$i18n.locale); // 如果需要持久化
            this.$emit('fetchData', res);
            this.getColumnList(); //重新获取菜单
          }
        });
      });
    },
    toback() {
      this.activeNav = [];
    },
    toPage(path) {
      this.$router.push({ path: path });
    },
  },
};
</script>

<style lang="scss" scoped>
header {
  background-color: white;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  position: sticky;
  top: 0;
  z-index: 100;
  .nav_container {
    height: 3.3333rem;
  }
  nav {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 3.3333rem;
    .logo {
      padding-left: 1.5rem;
      image {
        width: 7.75rem;
        height: 3.3333rem;
        object-fit: cover;
        object-position: center; /* 图片的中心与容器的中心对齐 */
      }
    }
    .nav-links {
      display: flex;
      list-style: none;
      display: none;
      padding: 0 2rem;
      height: calc(100vh);
      li {
        text-align: left;
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: 1.6667rem;
        height: 5.75rem;
        line-height: 2rem;
        border-bottom: solid 0.0625rem #c2c4ce;
        margin: 0;
        .arrow-right {
          width: 10px;
          height: 10px;
          background-color: transparent;
          border-color: #2a2a2a;
          border-style: solid;
          border-width: 2px 2px 0 0;
          transform: rotate(45deg);
        }
      }
    }
    .nav_right {
      display: flex;
      align-items: center;
      height: 5rem;
      img {
        width: 1.2rem;
        height: 1.2rem;

        object-fit: cover;
        object-position: center; /* 图片的中心与容器的中心对齐 */
      }
    }
  }
}

.menu-toggle {
  display: none;
  cursor: pointer;
  font-size: 1.5rem;
  width: 4.0625rem;
  height: 5rem;
  line-height: 5rem;
}
.lang_con {
  cursor: pointer;
  // width: 3.125rem;
  line-height: 5rem;
  height: 5rem;
  color: #2a2a2a;
  padding: 0 0.8333rem;
}
.subnav {
  position: relative;
  z-index: 2;
  background: #fff;
  padding: 0 2rem;
  height: calc(100vh);
  // height: calc(100vh-3.333rem);
  .back_con {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    color: #2a2a2a;
    font-size: 1.3333rem;
    height: 7rem;
  }
  .subnav_title {
    font-size: 2.6667rem;
    color: #2a2a2a;
    text-align: left;
  }
  .subnav_list {
    padding-top: 0.8333rem;
    li {
      text-align: left;
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-size: 1.6667rem;
      height: 4.3125rem;
      img {
        width: 1rem;
        height: 1rem;
      }
    }
  }
}

@media (max-width: 768px) {
  .nav-links {
    display: none;
    flex-direction: column;
    width: 100%;
    background: white;
    position: absolute;
    top: 100%;
    left: 0;
    box-shadow: 0 5px 10px rgba(0, 0, 0, 0.1);
  }

  .nav-links.active {
    display: flex;
  }

  .nav-links li {
    margin: 0.5rem 0;
  }

  .menu-toggle {
    display: block;
  }
}

::v-deep {
  .no-border-select {
    .el-input__inner {
      width: 70px;
      height: 26px;
      border: none !important;
      background-color: transparent !important;
      color: #2a2a2a;
    }
    .el-input__icon {
      line-height: 0;
    }
    .el-input__inner:hover {
      border: none !important;
    }
    .el-input__inner:focus {
      border: none !important;
    }
  }
}
</style>
